import { useConsultDoctorContext } from "../Contexts/ConsultDoctorContext";
import { CircularProgress, Divider } from "@mui/material";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { baseUrl } from "../utilities/configurations";
import apiRequest from "../utilities/request";
import ErrorComponent from "./ErrorComponent";
import { ScrollBar } from "./ScrollBar";
import { useEffect } from "react";
import dayjs from "dayjs";
import "./style.css";

const SearchSpecialization = () => {
  const {
    selectedSpecialization,
    convertToStandardTime,
    setSelectedDoctor,
    setSelectedTime,
    selectedDoctor,
    setDoctorsData,
    availableDates,
    selectedDate,
    selectedTime,
    setLoadState,
    doctorsData,
    physicians,
    loadState,
  } = useConsultDoctorContext();

  const isDoctorAvailableOnSelectedDate = async (doctorData) => {
    try {
      const availableDoctors = await doctorData
        .filter(Boolean)
        .filter(({ dates }) => dates.includes(selectedDate));
      // Now you can set the filtered available doctors data
      setDoctorsData(availableDoctors);
    } catch (error) {
      console.log(error);
    }
  };

  const getAvailableTimeOfEachDoctor = async (state) => {
    try {
      setLoadState(state || "get doctors");
      const doctorData = await Promise.all(
        physicians.map(async (doctor, index) => {
          try {

            const dates = availableDates.map((item) => item.date) || [];

            const timeResponse = await apiRequest(
              baseUrl +
                `/consult/times?date=${selectedDate}&specializationId=${selectedSpecialization.id}&physicianId=${doctor.id}`,
              "GET"
            );
            const times =
              timeResponse.data?.map((item) => ({
                time: dayjs(item.time).format("HH:mm"),
                slotsAvailable: item.slotsAvailable,
              })) || [];

            return { doctor, index, dates, times };
          } catch (error) {
            if (error.response && error.response.status === 404) {
              return null; // Return null to indicate that this doctor's response is not available
            } else {
              console.error(
                `Error fetching data for doctor ${doctor.id}:`,
                error
              ); // Log the error for debugging
              return { doctor, index, dates: [], times: [] }; // Return empty dates and times arrays
            }
          }
        })
      );
      isDoctorAvailableOnSelectedDate(doctorData); // Pass doctorData to isDoctorAvailableOnSelectedDate
      setLoadState("get doctors success");
    } catch (error) {
      setLoadState("get doctors failed");
      console.error("Error in getting available date and time of each doctor:", error); // Log the error for debugging
    }
  };

  useEffect(() => {
    if (selectedDate) {
      getAvailableTimeOfEachDoctor();
    }
  }, [selectedDate]);

  const groupDoctorsByTimeSlot = (doctorsData) => {
    const groupedDoctors = {};

    doctorsData.forEach((doctorEntry) => {
      doctorEntry.times.forEach((timeSlot) => {
        if (!groupedDoctors[timeSlot.time]) {
          groupedDoctors[timeSlot.time] = [];
        }
        groupedDoctors[timeSlot.time].push(doctorEntry.doctor);
      });
    });

    return groupedDoctors;
  };

  const handleSelectDoctorTimeslot = (doctor, timeSlot) => {
    setSelectedDoctor(doctor);
    setSelectedTime(timeSlot);
  };

  const renderDoctorsByTimeSlot = (groupedDoctors) => {
    // Sort time slots
    const sortedTimeSlots = Object.keys(groupedDoctors).sort((a, b) => {
      // Assuming time slots are in format "HH:mm"
      return new Date(`1970-01-01T${a}`) - new Date(`1970-01-01T${b}`);
    });

    // Render doctors by sorted time slots
    return (
      <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
        <ScrollArea.Viewport className="w-full sm:h-52 h-[70vh] rounded">
          {sortedTimeSlots.map((timeSlot) => (
            <div key={timeSlot}>
              <Divider
                textAlign="left"
                textColor="#60656D"
                sx={{
                  "& .MuiDivider-wrapper": { padding: 0, paddingRight: 2 },
                  "&::before": { width: 0 },
                }}
              >
                {convertToStandardTime(timeSlot)}
              </Divider>

              {groupedDoctors[timeSlot].map((doctor) => (
                <div key={doctor} className="flex flex-row my-2 ">
                  <label id="labl" className="w-full mt-1 cursor-pointer">
                    <input
                      name="doctor"
                      id="doctor"
                      type="radio"
                      onChange={() =>
                        handleSelectDoctorTimeslot(doctor, timeSlot)
                      }
                      checked={
                        selectedDoctor?.id === doctor.id && selectedTime === timeSlot
                      }
                    />
                    <div className=" w-full text-sm p-3 border rounded-lg ">
                      {doctor.name}
                    </div>
                  </label>
                </div>
              ))}
            </div>
          ))}{" "}
        </ScrollArea.Viewport>
        <ScrollBar />
      </ScrollArea.Root>
    );
  };

  let content = null;
  if (loadState === "get doctors") {
    content = (
      <div className="w-full flex justify-center items-center mt-4">
        <CircularProgress />
      </div>
    );
  } else if (loadState === "get doctors failed") {
    content = (
      <ErrorComponent
        onRetry={() => getAvailableTimeOfEachDoctor("get doctors retry")}
        isLoading={loadState === "get doctors retry"}
      />
    );
  } else if (
    selectedSpecialization &&
    selectedDate &&
    doctorsData &&
    doctorsData.length > 0
  ) {
    content = renderDoctorsByTimeSlot(groupDoctorsByTimeSlot(doctorsData));
  } else {
    content = (selectedSpecialization || selectedDate) && (
      <p>No doctors available.</p>
    );
  }

  return content;
};

export default SearchSpecialization;
